module.exports = __webpack_public_path__ + "img/podd.6c484dc7.svg";